import React, { Component } from 'react'
import "./skill.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { getApiResultList , getApiZsType } from '../../axios/api'
import { Pagination } from 'antd';
import 'antd/dist/antd.css';
import { get } from '../../axios/localstorage'

export default class skill extends Component {

    state = {
        page:1,
        total:1,
        type:"",
        zsTypeList:[],
        showMore:false,
        list:[],
        key:"",

        showNone:false,
    }

    componentWillMount(){
        window.scroll(0,0);

        let nameData = get('name');
        if(nameData){
        this.setState({
            name:nameData.name,
            arrType:nameData.nameType
        })

        // remove('name')
    }

        getApiZsType()
        .then( req =>{
            if(req.data.code === 1){

                let data = req.data.data;

                this.setState({
                    zsTypeList:data.list,
                    provinceList:data.province,

                })
            }
        }).catch( err =>{
            console.error(err);
        })

        this.changePage(1);
    }

    gotoPage=(page)=>{
        this.props.history.push(page);

        
    }

    gotoInfoPage=(page)=>{
 
        let str = window.location.href;
        var num=str.indexOf("#/") 
        str=str.substr(0,num+1); //取得所有参数   stringvar.substr(start [, length ]

        window.open(str + page);
    }

    changePage=(page)=>{
        this.setState({
            page
        })

        setTimeout(()=>{
            this.getList();
        },50)
    }

    changeName=(name)=>{

        let param = {
            type_id:this.state.type,
            page:this.state.page,
            keywords:name
        }

        getApiResultList(param)
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                this.setState({
                    list:data.list,
                    total:data.total
                })

                if(data.total){
                    this.setState({
                        showNone:false
                    })
                }else{
                    this.setState({
                        showNone:true
                    })
                }
            }
        }).catch( err =>{
            console.error(err);
            this.setState({
                showNone:true
            })
        })
    }

    getList=()=>{
        let param = {
            type_id:this.state.type,
            page:this.state.page,
            keywords:this.state.name
        }

        getApiResultList(param)
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                this.setState({
                    list:data.list,
                    total:data.total
                })

                if(data.total){
                    this.setState({
                        showNone:false
                    })
                }else{
                    this.setState({
                        showNone:true
                    })
                }
            }
        }).catch( err =>{
            console.error(err);
            this.setState({
                showNone:true
            })
        })
    }

    render() {
        return (
            <div className='skill'>
                <Header type={6} changeName={this.changeName} />
                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            <div className='hname'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p>科技成果</p>
                            </div>

                            <div className='hbox'>
                                <div className='hdiv'>
                                    <h2>所属领域：</h2>
                                    <div className={this.state.showMore?'hflex hauto':'hflex'}>
                                        <div onClick={()=>{this.setState({type:""});this.changePage(1)}} className={this.state.type === ""?"chosn":""}>全部</div>
                                        {
                                            this.state.zsTypeList.map((item,index)=>{
                                                return <div key={index}  onClick={()=>{this.setState({type:item.id});this.changePage(1)}} className={this.state.type === item.id?"chosn":""}>{item.title}</div>
                                            })
                                        }

                                        <div className='more' onClick={()=>{this.setState({showMore:!this.state.showMore})}}>
                                            <p>{this.state.showMore?"收起":"更多"}</p>
                                            <img alt="" src={this.state.showMore?"/www/assets/imgs/gengduo2.png":"/www/assets/imgs/gengduo.png"} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='page'>
                    <div className='cen'>
                        <div className='main'>
                            <div className='box'>
                            {
                                this.state.list.map((item,index)=>{
                                    return <div className='item' onClick={()=>{this.gotoInfoPage('/skillinfo?id='+item.id )}} key={index}>
                                                <h2>{item.title}</h2>
                                                
                                                <div className='cbox'>
                                                    <div>{item.industry_text}</div>
                                                    {/* <h4>项目负责人：<span>{item.head}</span></h4>
                                                    <h4>工作单位：<span>{item.company}</span></h4> */}
                                                </div>
                                                <p>{item.info}</p>
                                            </div>
                                })
                            }

                            <div className='none' hidden={!this.state.showNone}>
                                    <div className='cen'>
                                        <img alt="" src="/www/assets/imgs/zanwuxuexineirong.png" />
                                    </div>
                                    <p>暂无相关科技成果</p>
                                </div>
                            
                            </div>
                            <div className='r_page'>
                                <Pagination type="success" showSizeChanger={false} pageSize={18}  defaultCurrent={this.state.page} total={this.state.total} onChange={(page)=>{this.changePage(page)}} />
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        )
    }
}
